$bog_ui_command $mol_view
	showed? false
	query? \
	commands /
	filtered /
	selected? 0
	sub /
		<= Backdrop $mol_view
			event *
				click? <=> backdrop_click? null
		<= Dialog $mol_view
			event *
				keydown? <=> key_down? null
			sub /
				<= Search $mol_string
					hint \Search commands…
					value? <=> query?
				<= Results $mol_list
					rows <= result_rows /
	attr *
		bog_ui_command_showed <= showed?

$bog_ui_command_group $mol_view
	title \
	sub /
		<= Title $mol_view
			sub /
				<= title

$bog_ui_command_item $mol_button_minor
	label \
	shortcut \
	active false
	click? <=> execute? null
	sub /
		<= Label $mol_view
			sub /
				<= label
		<= Shortcut $mol_view
			sub /
				<= shortcut
	attr *
		^
		bog_ui_command_item_active <= active
